import Events from 'tf-events-1';
import eventNames from './events/names';

const replace = () => {
	console.warn('url.replace is not implemented yet');
}

const push = () => {
	console.warn('url.push is not implemented yet');
}

const getHash = () => {
	return window.location.hash.slice(1);
}
const setHash = newHash => {
	window.location.hash = newHash;
}

const setUrl = newUrl => {
	if(history && history.pushState){
		history.pushState(null, document.title, newUrl);
	}else{
		window.location.href = newUrl;
	}
}

const events = Events();

const onhashchange = window.onhashchange;
window.onhashchange = () => {
	events.fire(eventNames.HASH, window.location.hash);
	
	if(onhashchange){
		onhashchange();
	}
}

export default {
	replace,
	push,
	setUrl,
	getHash,
	setHash,

	// events
	events: eventNames,
	on: events.on,
	once: events.once,
	off: events.off,
	batch: events.batch,
	ignore: events.ignore,
}